import addresses from "../config/addresses";

const chainId    = process.env.GATSBY_APP_CHAIN_ID;
const eth_id     = 1
const polygon_id = 137

export const CONTRACT_ADDRESS_WHELPS      = addresses.contract_whelps[chainId];
export const CONTRACT_ADDRESS_PROXY       = addresses.contract_proxy[chainId];
export const CONTRACT_ADDRESS_STAKING     = addresses.contract_staking[chainId];
export const CONTRACT_ADDRESS_STAKING_V2  = addresses.contract_staking_v2[chainId];
export const CONTRACT_ADDRESS_7THBREED    = addresses.contract_7thbreed[chainId];

export const CONTRACT_ADDRESS_WHELPS_Eth  = addresses.contract_whelps[eth_id];
export const CONTRACT_ADDRESS_WHELPS_Pol  = addresses.contract_whelps[polygon_id];
export const CONTRACT_ADDRESS_PROXY_Eth       = addresses.contract_proxy[eth_id];
export const CONTRACT_ADDRESS_PROXY_Pol       = addresses.contract_proxy[polygon_id];
export const CONTRACT_ADDRESS_STAKING_Eth    = addresses.contract_staking[eth_id];
export const CONTRACT_ADDRESS_STAKING_Pol    = addresses.contract_staking[polygon_id];
export const CONTRACT_ADDRESS_STAKING_V2_Eth  = addresses.contract_staking_v2[eth_id];
export const CONTRACT_ADDRESS_STAKING_V2_Pol  = addresses.contract_staking_v2[polygon_id];
export const CONTRACT_ADDRESS_7THBREED_Eth    = addresses.contract_7thbreed[eth_id];
export const CONTRACT_ADDRESS_7THBREED_Pol    = addresses.contract_7thbreed[polygon_id];
